import React, { useState, useRef, useEffect } from "react";
import { FiSmile } from "react-icons/fi";
import "../styles/ToneSelector.css";

const TONE_OPTIONS = [
  { value: "friendly", label: "Friendly", icon: "😊" },
  { value: "formal", label: "Formal", icon: "📝" },
  { value: "encouraging", label: "Encouraging", icon: "💪" },
  { value: "socratic", label: "Socratic", icon: "🤔" },
];

const ToneSelector = ({ selectedTone, onToneChange, loading }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const currentOption = TONE_OPTIONS.find((o) => o.value === selectedTone);

  return (
    <div className="tone-container" ref={containerRef}>
      <button
        type="button"
        className="tone-trigger"
        onClick={() => setIsOpen((v) => !v)}
        disabled={loading}
      >
        <FiSmile size={14} />
        <span className="tone-trigger-label">Tone</span>
        {currentOption && (
          <span className="tone-current">{currentOption.icon}</span>
        )}
        <span className="header-tooltip">
          Set the chatbot's conversational style and personality.
        </span>
      </button>

      {isOpen && (
        <div className="tone-popup">
          <div className="tone-popup-header">Chatbot Tone</div>
          {TONE_OPTIONS.map((opt) => {
            const isSelected = selectedTone === opt.value;
            return (
              <div
                key={opt.value}
                className={`tone-option${isSelected ? " tone-option-selected" : ""}`}
                onClick={() => {
                  if (!loading) {
                    onToneChange(opt.value);
                    setIsOpen(false);
                  }
                }}
              >
                <span className="tone-option-icon">{opt.icon}</span>
                <span className="tone-option-label">{opt.label}</span>
                {isSelected && <span className="tone-check">✓</span>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ToneSelector;
